module.exports = __webpack_public_path__ + "static/media/compartir.43714637.svg";